// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rz2t","colBig":"styles_colBig__2aWW2","colSmall":"styles_colSmall__2X_dC"};